<template>

  <div class="Big" >

      <div style="position: absolute" :class="{'animated jackInTheBox fast delay-0.5s':Bigbtn.one,'animated fadeOutRight faster':!Bigbtn.one}">
        <div class="Bigbtn animated pulse infinite " v-on:click="Goin(0)">
        <div class="moremask">MORE</div>
      </div>
      </div>
    <div style="position: absolute" :class="{'animated jackInTheBox fast':Bigbtn.two,'animated fadeOutRight faster':!Bigbtn.two}">
      <div class="Bigbtn animated pulse  infinite" v-on:click="Goin(1)">
        <div class="moremask">MORE</div>
      </div>
    </div>
    <div style="position: absolute" :class="{'animated jackInTheBox fast':Bigbtn.three,'animated fadeOutRight faster':!Bigbtn.three}">
      <div class="Bigbtn animated pulse  infinite" v-on:click="Goin(2)">
        <div class="moremask">MORE</div>
      </div>
    </div>
    <div style="position: absolute" :class="{'animated jackInTheBox fast':Bigbtn.four,'animated fadeOutRight faster':!Bigbtn.four}">
      <div class="Bigbtn animated pulse  infinite" v-on:click="Goin(3)">
        <div class="moremask">MORE</div>
      </div>
    </div>
    <div style="position: absolute" :class="{'animated jackInTheBox fast':Bigbtn.five,'animated fadeOutRight faster':!Bigbtn.five}">
      <div class="Bigbtn animated pulse  infinite" v-on:click="Goin(4)">
        <div class="moremask">MORE</div>
      </div>
    </div>


  </div>


</template>

<script>

// 顯示順序：0 瓦里安介紹 / 1 放射治療 / 2 精準放射治療 / 3 適應性治療 / 4 質子治療
const BTNKEYS = ['one', 'two', 'three', 'four', 'five']

export default {

  props: {
    Target: Number
  },
  data () {
    return {
      Bigbtn: {
        one: false,
        two: false,
        three: false,
        four: false,
        five: false,
      },
    }
  },
  watch: {
    Target: function () {
      this.TargetSet(this.Target)
    }
  },
  mounted () {

    this.TargetSet(this.Target)
  },
  methods: {
    TargetSet (t) {
      BTNKEYS.forEach((k, i) => {
        this.Bigbtn[k] = i === t
      })
    },
    Goin (v) {

      switch (v) {
        case 0:
          this.$router.push('/About')
          break
        case 1:
          this.$router.push('/Radiation')
          break
        case 2:
          this.$router.push('/Technology')
          break
        case 3:
          this.$router.push('/Adaptive')
          break
        case 4:
          this.$router.push('/Proton')
          break
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .Bigbtn {
    position: relative;
    width: 300px;
    height: 300px;
    background-image: url("../assets/gobtn.png");
    background-position: center;
    background-size: 100%;
    background-repeat: no-repeat;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  /* 蓋住底圖裡燒死的 MORE，改用可編輯的文字 */
  .moremask {
    width: 174px;   /* 底圖黑圓直徑為圖寬的 57.9% */
    height: 174px;
    border-radius: 50%;
    background-color: #000;
    color: #ec6604;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.6rem;
    letter-spacing: 2px;
  }

  .Big {

    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 1080px;
    width: 1920px;
  }



</style>
